import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Import Global CSS Files
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/SK.css';

ReactDOM.render(<App />, document.getElementById('root'));